<template>
  <div
    v-if="caseInformation"
    class="case-inform"
  >
    <!--Search and help block-->
    <b-row class="search-block mb-2 mt-1">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="6"
      >
        <searcher-module
          name="diagnosisSearcher"
          popover-id="popover-diagnosis-form"
          :error-message="$tc('diagnosis.errors.validIdentifier')"
          subportion-search
          case-search
          @subportionSearch="onSubportionSearch($event)"
          @studySearch="onStudySearch($event)"
        />
      </b-col>
      <b-col
        xl="8"
        lg="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <div style="margin-top: 5px;">
          <b-button
            v-shortkey="['f10']"
            qa="diagnosis-case-inform-patients-button"
            class="btn__link px-3"
            @shortkey.prevent="openPatientModal"
            @click="openPatientModal"
          >
            <i
              class="far fa-users mr-2"
              aria-hidden="true"
            />{{ $tc('global.patients') }}
          </b-button>
          <b-button
            v-tooltip="$tc('global.statusOptions.incidence',2)"
            class="round-btn round-btn--incidents mr-0"
            @click="openIncidentsModal()"
          >
            <i
              class="fal fa-exclamation-triangle"
              aria-hidden="true"
            />
          </b-button>
          <b-button
            v-tooltip="$tc('global.file',2)"
            qa="diagnosis-case-inform-attachments-button"
            class="round-btn round-btn--attachments ml-2 mr-1"
            @click="openAttachModalPatient"
          >
            <i
              class="fal fa-paperclip"
              aria-hidden="true"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row class="diagnosis-case__container">
      <!--Case Column: Variable Data according to the view mode-->
      <b-col
        class="pr-0 d-none d-md-flex"
        xl="2"
        lg="3"
        md="3"
        :class="[showCase ? 'case-col' : 'case-compact-col', !showCase]"
      >
        <b-card class="diagnosis-case-card float-component">
          <div
            class="d-flex fixed-section"
            :class="{'align-items-center': showCase, 'justify-content-center': showCase}"
          >
            <div
              v-if="!showCase"
              class="d-flex flex-column w-100 is-compact"
            >
              <div class="vertical-title">
                <span
                  class="font-weight--medium primary-dark-color"
                  qa="diagnosis-case-inform-case-label-compact-span"
                >{{ caseInformation.casenumber }}</span>
              </div>
              <!-- TODO: Add ModalCaseCard on clicking next button -->
              <b-button class="btn__icon btn__icon--primary mb-2">
                <i
                  class="main far fa-chart-network"
                  aria-hidden="true"
                />
              </b-button>
              <div class="d-flex justify-content-center my-2">
                <priority-dot :priority="caseInformation.priority" />
              </div>
              <div class="d-flex justify-content-center my-2">
                <case-status-badge
                  v-tooltip="caseInformation.status.name"
                  class="status-badge contract"
                  :status="caseInformation.status"
                />
              </div>
              <div>
                <hr class="mb-0 mt-2">
              </div>
              <div>
                <div
                  v-if="caseInformation.caseOfReference"
                  class="d-flex justify-content-center my-2"
                >
                  <b-badge
                    v-tooltip="$t('registry.btn.consultation')"
                    class="icon-badge indicator-bubble d-flex align-items-center justify-content-center"
                    pill
                  >
                    <i
                      class="far fa-glasses"
                      aria-hidden="true"
                    />
                  </b-badge>
                </div>
                <!-- TODO: Enlazar indicador de estudio compartido -->
                <!--<div class="d-flex justify-content-center my-2">
                                    <b-badge class="icon-badge indicator-bubble d-flex align-items-center justify-content-center"
                                             v-tooltip="$t('diagnosis.modals.caseShared')"
                                              pill>
                                        <i class="far fa-share" aria-hidden="true"></i>
                                    </b-badge>
                                </div>-->
                <div
                  v-if="caseInformation.lastAmendmentDate"
                  class="d-flex justify-content-center my-2"
                >
                  <b-badge
                    v-tooltip="$t('global.amendedCase')"
                    class="icon-badge indicator-bubble d-flex align-items-center justify-content-center"
                    pill
                  >
                    <i
                      class="far fa-money-check-edit"
                      aria-hidden="true"
                    />
                  </b-badge>
                </div>
              </div>
              <div>
                <hr class="mb-0 mt-1">
              </div>
              <div>
                <diagnosis-main-buttons
                  :class="'flex-column'"
                  :tooltip-placement="'right'"
                  :laboratory-id="labId"
                  :case-id="casId"
                  :show-content="viewSelected"
                  :is-case-validated="$_isCaseValidated(caseInformation && caseInformation.status.code)"
                  :has-comprehensive-diagnosis="caseInformation.hasComprehensiveDiagnosis"
                  :complementaries-count="caseInformation.complementariesCount"
                  :samples-count="caseInformation.samplesCount"
                  @changeViewSelected="changeView"
                  @openIncidentFormModal="openIncidentFormModal('CASE', {casId})"
                  @openAddFileModal="showAddFileModal(ENTITIES.CASE, [labId, casId])"
                  @openReportHistoryModal="showReportHistoryModal()"
                />
              </div>
              <div>
                <hr class="mt-0 mb-2">
              </div>
              <div class="text-center">
                <vt-loading-button
                  v-if="$_canPrintCaseReport()"
                  v-tooltip="{title:$t('diagnosis.btns.report'), placement: 'right'}"
                  class="btn__icon btn__icon--primary"
                  :params="{ promise: showAPReport, shortkeys: ['ctrl', 'shift', 'v'] }"
                >
                  <i
                    class="far fa-file-contract"
                    aria-hidden="true"
                  />
                </vt-loading-button>
              </div>
            </div>
            <div v-if="showCase">
              <div class="d-flex align-items-center">
                <!-- TODO: Add ModalCaseCard on clicking next button -->
                <b-button class="btn__icon btn__icon--primary far fa-chart-network mx-1" />
                <span
                  class="font-weight--medium primary-dark-color"
                  qa="diagnosis-case-inform-case-label-expand-span"
                >{{ caseInformation.casenumber }}
                  <i
                    v-if="visibleHasUnauthorizedBillableConceptsIcon(caseInformation.hasUnauthorizedBillableConcepts)"
                    v-tooltip="$t('global.hasUnauthorizedBillableConcepts')"
                    aria-hidden="true"
                    class="ml-1 fas fa-calculator danger-color"
                  /> </span>
                <div class="d-flex case-alerts">
                  <vtBubble
                    qa="diagnosis-case-inform-case-incidents-div"
                    class="ml-1"
                    :tooltip="' '+$t('grid.detail.hasAlarms')"
                    :number="caseInformation.incidentsCount"
                    :type="true"
                    @click="openIncidentsModal({coreEntity: 'CASE', casId})"
                  />
                  <vtBubble
                    qa="diagnosis-case-inform-case-attachments-div"
                    :tooltip="' '+$tc('global.file',2)"
                    :number="caseInformation.attachmentsCount"
                    :type="false"
                    @click="openAttachModalCase(casId)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="showCase">
            <div>
              <div class="horizontal-divider mb-0 mt-0" />
            </div>
            <diagnosis-main-buttons
              ref="diagnosisMainButtons"
              :class="'justify-content-around'"
              :tooltip-placement="'top'"
              :show-content="viewSelected"
              :case-data="caseInformation"
              :consultations="consultations"
              :laboratory-id="labId"
              @changeViewSelected="changeView"
              @customSentNotificationsUpdated="getCustomSentNotifications"
              @openIncidentFormModal="openIncidentFormModal('CASE', {casId})"
              @openAddFileModal="showAddFileModal(ENTITIES.CASE, [labId, casId])"
              @openReportHistoryModal="showReportHistoryModal()"
              @showConsultationModal="showConsultationModal()"
            />
          </div>
          <diagnosis-case-card
            v-if="showCase"
            ref="diagnosisCaseCard"
            :show-content="viewSelected"
            :lab-id="labId"
            :case-data="caseInformation"
            :consultations="consultations"
            :custom-sent-notifications-summary="customSentNotificationsSummary"
            @showCustomSentNotifications="showCustomSentNotifications"
            @updateCase="reloadCase"
            @showConsultationModal="showConsultationModal()"
            @reload-info-concepts="onReloadInfoConcepts()"
          />
          <div
            v-if="showCase"
            slot="footer"
            class="justify-content-end d-none d-md-flex"
          >
            <b-button
              qa="diagnosis-case-inform-hide-all-button"
              class="btn__icon btn__icon--primary p-2"
            >
              <i
                v-shortkey="['ctrl', 'alt', 'f2']"
                class="far fa-chevron-double-left"
                aria-hidden="true"
                @shortkey.prevent="hideAll"
                @click="hideAll()"
              />
            </b-button>
            <b-button
              v-shortkey="['alt', 'f2']"
              qa="diagnosis-case-inform-hide-case-button"
              class="btn__icon btn__icon--primary p-2"
              @shortkey.prevent="showCase=!showCase"
              @click="showCase=!showCase"
            >
              <i
                class="far fa-chevron-left"
                aria-hidden="true"
              />
            </b-button>
          </div>
          <div
            v-if="!showCase"
            slot="footer"
            class="d-flex justify-content-end"
          >
            <b-button
              qa="diagnosis-case-inform-show-all-button"
              class="btn__icon btn__icon--primary px-1"
            >
              <i
                v-shortkey="['ctrl', 'alt', 'f2']"
                class="far fa-chevron-double-right"
                aria-hidden="true"
                @shortkey.prevent="showAll"
                @click="showAll"
              />
            </b-button>
            <b-button
              v-shortkey="['alt', 'f2']"
              qa="diagnosis-case-inform-show-case-button"
              class="btn__icon btn__icon--primary px-1"
              @shortkey.prevent="showCase=!showCase"
              @click="showCase=!showCase"
            >
              <i
                class="far fa-chevron-right"
                aria-hidden="true"
              />
            </b-button>
          </div>
        </b-card>
      </b-col>

      <!--Samples Column: Variable Data according to the view mode-->
      <b-col class="workarea-col">
        <!--Patient Card-->
        <div class="entity-card mb-1">
          <b-row class="py-2 px-3 justify-content-sm-between">
            <b-col
              xl="3"
              lg="4"
              md="5"
              sm="5"
              class="d-flex align-items-center"
            >
              <b-button
                class="btn__icon btn__icon--primary"
                @click="showPatientModal"
              >
                <i
                  class="far fa-user-circle mr-2 main"
                  aria-hidden="true"
                />
              </b-button>
              <span
                class="entity-card__title d-flex align-items-center font-weight--medium truncated"
                qa="diagnosis-case-inform-patient-fullname-span"
              >
                {{ caseInformation.patient.fullName }}
              </span>
              <vtBubble
                qa="diagnosis-case-inform-patient-incidents-div"
                class="ml-1"
                :tooltip="` ${$t('grid.detail.hasAlarms')}`"
                :number="caseInformation.patient.incidentsCount"
                :type="true"
                @click="openIncidentsModal()"
              />
              <vtBubble
                qa="diagnosis-case-inform-patient-attachments-div"
                :tooltip="` ${$tc('global.file',2)}`"
                :number="caseInformation.patient.attachmentsCount"
                :type="false"
                @click="openAttachModalPatient"
              />
            </b-col>
            <b-col
              v-if="globalParameters.mainPatientIdentifierType"
              class="entity-card__data d-sm-none d-lg-flex"
            >
              <span class="entity-card__data--label">{{ globalParameters.mainPatientIdentifierType.name }}</span>
              <span
                class="entity-card__data--text"
                qa="diagnosis-case-inform-patient-main-identifier-span"
              >{{ caseInformation.patient.mainPatientIdentifier ? caseInformation.patient.mainPatientIdentifier.paiIdentifier : '-' }}</span>
            </b-col>
            <b-col
              v-if="globalParameters.secondaryPatientIdentifierType"
              class="entity-card__data d-sm-none d-xl-flex"
            >
              <span class="entity-card__data--label">{{ globalParameters.secondaryPatientIdentifierType.name }}</span>
              <span
                class="entity-card__data--text"
                qa="diagnosis-case-inform-patient-secondary-identifier-span"
              >{{ caseInformation.patient.secondaryPatientIdentifier ? caseInformation.patient.secondaryPatientIdentifier.paiIdentifier : '-' }}</span>
            </b-col>
            <b-col
              class="entity-card__data d-sm-none d-lg-flex"
            >
              <span class="entity-card__data--label">{{ $t('entities.patient.gender') }}</span>
              <span
                class="entity-card__data--text"
                qa="diagnosis-case-inform-patient-gender-span"
              >{{ caseInformation.patient.gender.name }}</span>
            </b-col>
            <b-col
              class="entity-card__data additional-data d-sm-none d-lg-flex"
            >
              <span class="entity-card__data--label">{{ $t('entities.patient.birthdate') }}</span>
              <span
                class="entity-card__data--text"
                qa="diagnosis-case-inform-patient-birthdate-span"
              >{{ caseInformation.patient.birthdate | date }}</span>
            </b-col>
            <b-col
              class="entity-card__data additional-data d-sm-none d-lg-flex"
            >
              <span class="entity-card__data--label">{{ $t('global.age') }}</span>
              <span
                class="entity-card__data--text"
                qa="diagnosis-case-inform-patient-age-span"
              >{{ patientTimeOld }}</span>
            </b-col>
            <b-col
              lg
              md="3"
              sm="3"
              class="d-flex align-items-center justify-content-end"
            >
              <b-button
                id="requestsCleanFilters"
                v-tooltip="$t('registry.cases.patientCases')"
                qa="diagnosis-case-inform-previous-cases-button"
                class="btn__icon btn__icon--primary mx-1"
                style="position:relative"
                @click="openPatientPreviousCasesModal"
              >
                <i
                  class="fas fa-history"
                  aria-hidden="true"
                />
                <div class="btn-badge">
                  <span class="badge vt-nav-badge indicator-bubble badge-secondary">
                    {{ patientPreviousCasesCount }}
                  </span>
                </div>
              </b-button>
              <!-- TODO: Oculto de momento a petición de Javier hasta versiones futuras -->
              <!--<b-button class="btn__icon btn__icon--primary mx-2 d-none d-xl-block"
                                                          v-tooltip="$t('diagnosis.btns.his')">
                                              <i class="far fa-address-card" aria-hidden="true"/>
                                            </b-button>-->
              <b-button
                v-if="$_canPrintPreviousCaseReport()"
                v-tooltip="$t('registry.cases.printCases')"
                qa="diagnosis-case-inform-print-cases-button"
                class="btn__icon btn__icon--primary mx-2 d-none d-xl-block"
                @click="exportPatientPreviousCasesReportPDF"
              >
                <i
                  aria-hidden="true"
                  class="fas fa-print"
                />
              </b-button>
              <span v-if="$_canCreateIncident() || $_canAttachDocumentToPatient()">
                <b-button
                  id="patient-diag-card"
                  class="simple-pop btn__icon btn__icon--primary"
                  variant="primary"
                >
                  <i
                    aria-hidden="true"
                    class="ml-2 fas fa-ellipsis-v"
                  />
                </b-button>
                <b-popover
                  target="patient-diag-card"
                  placement="bottom"
                  triggers="click blur"
                >
                  <div class="ap-popover">
                    <ul>
                      <!-- TODO: Oculto de momento a petición de Javier hasta versiones futuras -->
                      <!--<li class="py-1 d-xl-none">
                                                              <a type="button" class="linkbtn">
                                                                <i class="far fa-address-card mr-2" aria-hidden="true"/>
                                                                {{$t('diagnosis.btns.his')}}
                                                              </a>
                                                            </li>-->
                      <li
                        v-if="$_canPrintPreviousCaseReport()"
                        class="d-xl-none"
                      >
                        <b-button
                          @click="exportPatientPreviousCasesReportPDF"
                        >
                          {{ $t('registry.cases.printCases') }}
                        </b-button>
                      </li>
                      <div class="horizontal-divider my-1 d-xl-none" />
                      <li
                        v-if="$_canCreateIncident()"
                      >
                        <b-button
                          @click="openIncidentFormModal('PATIENT', {patId: caseInformation.patient.id})"
                        >
                          {{ $t('diagnosis.btns.incident') }}
                        </b-button>
                      </li>
                      <li
                        v-if="$_canAttachDocumentToPatient()"
                      >
                        <b-button
                          :disabled="!$_canBeDocumentAttachedToPatient(caseInformation)"
                          @click="showAddFileModal(ENTITIES.PATIENT, [ caseInformation.patient.id ])"
                        >
                          {{ $t('diagnosis.btns.attach') }}
                        </b-button>
                      </li>
                    </ul>
                  </div>
                </b-popover>
              </span>
            </b-col>
          </b-row>
        </div>
        <!--Main card-->
        <div class="main-card float-component">
          <b-container>
            <b-row class="h-100">
              <b-col class="h-100">
                <macro-diagnosis
                  v-if="viewSelected===FORM_VIEWS_CONFIGURATION.MACRO_VIEW.id"
                  :lab-id="labId"
                  :cas-id="casId"
                  :case-label="caseLabel"
                  @selectSampleFromMacro="selectSampleFromMacro"
                />
                <samples-diagnosis
                  v-if="viewSelected===FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id"
                  ref="samplesView"
                  :show-sample="showSample"
                  :lab-id="labId"
                  :case-study="caseInformation"
                  :case-collapsed="showCase"
                  @hideSampleCard="hideSampleCard"
                  @showSampleCard="showSampleCard"
                  @updateCase="reloadCase"
                  @showIncidentsModalForSubportion="openIncidentsModal($event)"
                  @sampleSelected="sample = $event"
                  @showSubportionAttachmentTreeModal="openAttachModalSubportion($event)"
                  @openIncidentFormModal="openIncidentFormModal($event.coreEntity, $event.entitiesIds)"
                  @showIncidentsModal="openIncidentsModal($event)"
                  @show-sample-attachment-tree-modal="openAttachModalSample($event)"
                  @openAddFileModalForSample="showAddFileModal(ENTITIES.SAMPLE, $event)"
                  @openAddFileModalForPortion="showAddFileModal(ENTITIES.PORTION, $event)"
                  @openAddFileModalForSubportion="showAddFileModal(ENTITIES.SUBPORTION, $event)"
                />
                <integral-diagnosis
                  v-if="viewSelected===FORM_VIEWS_CONFIGURATION.DIAGNOSIS_INTEGRAL_VIEW.id"
                  ref="integralView"
                  :lab-id="labId"
                  :case-data="caseInformation"
                  @updateCase="reloadCase"
                />
                <complementaries-diagnosis
                  v-if="viewSelected===FORM_VIEWS_CONFIGURATION.COMPLEMENTARIES_VIEW.id"
                  ref="complementariesView"
                  :lab-id="labId"
                  :cas-id="casId"
                  :is-case-in-amendment="$_isCaseInAmendment(caseInformation && caseInformation.status.code)"
                  @updateCase="reloadCase"
                  @show-complementary-attachment-tree-modal="openAttachModalComplementary($event)"
                />
              </b-col>
              <b-col
                cols="auto"
                class="d-flex align-items-center left-bordered px-1"
                style="border-left:1px solid #d8d8d8;"
              >
                <VtBreadCrumbs
                  v-if="showBreadCrumbs"
                  :lab-id="labId"
                  :case-study="caseInformation"
                  :samples="getSamples"
                />
              </b-col>
            </b-row>
          </b-container>
          <!-- Main card footer -->
          <div class="main-footer top-bordered p-2 align-items-center d-flex justify-content-end">
            <b-form-checkbox
              v-model="caseInformation.transcriptionRequired"
              qa="diagnosis-case-inform-transcription-checkbox-div"
              :disabled="isCaseTranscribed || !$_canEditCase() || !$_isCaseEditable(caseInformation && caseInformation.status.code)"
              class="mr-3"
              :value="true"
              :unchecked-value="false"
              @input="updateTranscriptionRequired"
            >
              <span class="dark">{{ $t('diagnosis.labels.transcriptionRequired') }}</span>
            </b-form-checkbox>
            <b-button
              v-if="visibleInformButton"
              v-shortkey="['alt', 'i']"
              :disabled="!$_canBeCaseInformed(caseInformation)"
              qa="diagnosis-case-inform-inform-button"
              class="btn__outline ml-2"
              size="sm"
              @shortkey="saveChangesAndApplyAction(informCase)"
              @click="saveChangesAndApplyAction(informCase)"
            >
              <i
                class="fal fa-file-chart-line mr-2"
                aria-hidden="true"
              />
              {{ $t('diagnosis.btns.inform') }}
            </b-button>
            <b-button
              v-if="visibleInformAndValidateButton"
              v-shortkey="['ctrl', 'enter']"
              :disabled="disabledInformAndValidateButton"
              qa="diagnosis-case-inform-inform-and-validate-button"
              class="btn--primary ml-2"
              size="sm"
              @shortkey.prevent="saveChangesAndApplyAction(informAndValidate)"
              @click="saveChangesAndApplyAction(informAndValidate)"
            >
              <i
                class="fal fa-check mr-2"
                aria-hidden="true"
              />
              {{ $t('diagnosis.labels.informValidate') }}
            </b-button>
            <b-button
              v-if="visibleTranscribeButton"
              qa="diagnosis-case-inform-transcribe-button"
              class="btn__outline ml-2"
              size="sm"
              @click="saveChangesAndApplyAction(transcribeCase)"
            >
              <i
                class="fal fa-keyboard mr-2"
                aria-hidden="true"
              />
              {{ $t('diagnosis.labels.transcribe') }}
            </b-button>
            <b-button
              v-if="visibleValidateButton"
              v-shortkey="['alt', 'v']"
              qa="diagnosis-case-inform-validate-button"
              class="btn--primary ml-2"
              size="sm"
              @shortkey.prevent="saveChangesAndApplyAction(validateCase)"
              @click="saveChangesAndApplyAction(validateCase)"
            >
              <i
                class="fal fa-check mr-2"
                aria-hidden="true"
              />
              {{ $t('diagnosis.btns.validate') }}
            </b-button>
            <b-button
              v-if="visibleInvalidateButton"
              qa="diagnosis-case-inform-invalidate-button"
              class="btn--primary ml-2"
              size="sm"
              @click="saveChangesAndApplyAction(invalidateCase)"
            >
              <i
                class="fal fa-undo mr-2"
                aria-hidden="true"
              />{{ $t('diagnosis.btns.invalidate') }}
            </b-button>
            <b-button
              v-if="visibleAmendButton"
              qa="diagnosis-case-inform-create-amendment-button"
              class="btn--primary ml-2"
              size="sm"
              @click="saveChangesAndApplyAction(addAmendment)"
            >
              {{ $t('diagnosis.btns.createAmendment') }}
            </b-button>
            <b-button
              v-if="visibleValidateAmendmentButton"
              qa="diagnosis-case-inform-validate-amendment-button"
              class="btn--primary ml-2"
              size="sm"
              @click="saveChangesAndApplyAction(validateAmendment)"
            >
              {{ $t('diagnosis.btns.validateAmendment') }}
            </b-button>
            <b-button
              v-if="visibleConsultations"
              qa="diagnosis-case-inform-reply-consult-button"
              class="btn--primary ml-2"
              size="sm"
              @click="showConsultationModal(consultationToolbarSelectorTypeEnum.PENDING_CONSULTATIONS)"
            >
              {{ $tc('diagnosis.btns.replyConsult') }}
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <!--Modals-->
    <modal-patient-card
      v-if="caseInformation"
      ref="modalPatientCard"
      :patient-id="caseInformation.patient.id"
    />
    <search-patient-modal
      ref="searchPatientModal"
      id-modal="searchPatientModal"
      @closePreviousCasesWindow="closePreviousCasesWindow"
    />
    <common-incident-modal-tree ref="incidentModalTree" />
    <common-attachment-tree-modal
      v-if="caseInformation"
      ref="attachmentTreeModal"
      :patient="caseInformation.patient"
      :laboratory-id="labId"
      @attachments-updated="reloadViewAfterIncidentOrAttachmentAdded"
    />
    <incident-form-modal
      ref="incidentFormModal"
      :core-entity="coreEntity"
      @incident-added="reloadViewAfterIncidentOrAttachmentAdded"
    />
    <modal-wrapper ref="addFileModalWrapper">
      <add-file-modal
        id="addFileModal"
        ref="addFileModal"
        :attachment-entity-type="coreEntity"
        :entities-id-array="entitiesIdArray"
        @attachmentsAdded="onAttachmentsAdded()"
      />
    </modal-wrapper>
    <report-history-modal
      ref="reportHistoryModal"
      :case-label="caseLabel"
    />

    <diagnosis-consultation-modal
      ref="consultationModal"
      :case-id="casId"
      :case-number="caseInformation.casenumber"
      :pathologist-id="casePathologistId"
      :consultations.sync="consultations"
    />
    <print-component ref="printComponent" />
  </div>
</template>

<script>
import SearchPatientModal from '@/components/searcherPatientModal/SearchPatientModal'
import SearcherModule from '@/components/SearcherModule'
import VtBubble from '@/components/common/VtBubble'
import DiagnosisCaseCard from '@/modules/diagnosisModule/views/form/DiagnosisCaseCard'
import VtBreadCrumbs from '@/components/common/VtBreadCrumbs'
import diagnosisCaseService from '../../services/DiagnosisCaseService'
import FORM_VIEWS_CONFIGURATION from '@/modules/diagnosisModule/views/form/config/formViewsConfiguration'
import ModalPatientCard from '@/components/modals/ModalPatientCard'
import DiagnosisMainButtons from '@/modules/diagnosisModule/views/form/DiagnosisMainButtons'
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'
import MacroDiagnosis from '@/modules/diagnosisModule/views/form/macroView/MacrosOfCase'
import SamplesDiagnosis from '@/modules/diagnosisModule/views/form/samplesView/SamplesDiagnosis'
import IntegralDiagnosis from '@/modules/diagnosisModule/views/form/integralDiagnosisView/IntegralDiagnosis'
import ComplementariesDiagnosis from '@/modules/diagnosisModule/views/form/complementariesView/ComplementariesDiagnosis'
import { CASE_STATES } from '@/api/resources/entityState/case-state'
import sessionStore from '@/session/sessionStore'
import CommonAttachmentTreeModal from '@/components/attachments/CommonAttachmentModalTree'
import CommonIncidentModalTree from '@/components/incidentsModal/CommonIncidentModalTree'
import IncidentFormModal from '@/components/incidentsModal/IncidentFormModal'
import AddFileModal from '@/components/AddFileModal'
import commonCaseServices from '@/api/resources/common/commonCaseServices'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import patientAttachmentService from '@/api/resources/attachment/patientAttachmentService'
import caseAttachmentService from '@/api/resources/attachment/caseAttachmentService'
import sampleAttachmentService from '@/api/resources/attachment/sampleAttachmentService'
import portionAttachmentService from '@/api/resources/attachment/portionAttachmentService'
import subportionAttachmentService from '@/api/resources/attachment/subportionAttachmentService'
import diagnosisMixin from '@/modules/diagnosisModule/mixins/diagnosisMixin'
import parameterService from '@/api/resources/parameterService'
import { CaseOperation } from '@/api/operations/models/case-operation'
import ReportHistoryModal from '@/modules/diagnosisModule/views/form/modals/ReportHistoryModal'
import CaseStatusBadge from '@/components/common/CommonCaseStatusBadge'
import customNotificationsService from '@/api/resources/customNotifications/customNotificationsService'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import { PatientOperationGuardMixin } from '@/api/operations/mixins/guards/patient-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import PatientResource from '@/api/resources/PatientResource'
import { cloneDeep } from 'lodash'
import DiagnosisConsultationModal
    from '@/modules/diagnosisModule/views/form/modals/consultation/modal/diagnosis-consultation-modal.vue'
import { diagnosisConsultationService } from '@/modules/diagnosisModule/services/diagnosis-consultation/diagnosis-consultation.service'
import { ConsultationToolbarSelectorTypeEnum } from '@/modules/diagnosisModule/views/form/modals/consultation/modal-toolbar/diagnosis-consultation-modal-toolbar.model'
import { DiagnosisConsultationStatusEnum } from '@/modules/diagnosisModule/services/diagnosis-consultation/diagnosis-consultation.dto'
import { viewerService } from '@/modules/viewerModule/services/viewer.service'
import diagnosisSideBarStore from '@/modules/diagnosisModule/sideBar/DiagnosisSideBarStore'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'
import { router } from '@/router'
import { HelperUtils } from '@/shared/util/helper-utils'
import { reportType } from '@/modules/printModule/print-component.model'
import { PromiseUtils } from '@/shared/util/promise-utils'

export default {
    name: 'DiagnosisCaseInform',
    components: {
        SearcherModule,
        VtBubble,
        DiagnosisCaseCard,
        VtBreadCrumbs,
        ModalPatientCard,
        DiagnosisMainButtons,
        MacroDiagnosis,
        SamplesDiagnosis,
        IntegralDiagnosis,
        ComplementariesDiagnosis,
        PriorityDot,
        CommonAttachmentTreeModal,
        CommonIncidentModalTree,
        IncidentFormModal,
        AddFileModal,
        SearchPatientModal,
        ReportHistoryModal,
        CaseStatusBadge,
        DiagnosisConsultationModal
    },
    mixins: [
        diagnosisMixin,
        CaseOperationGuardMixin,
        IncidentOperationGuardMixin,
        PatientOperationGuardMixin
    ],
    beforeRouteLeave(to, from, next) {
        this.checkBeforeRoute(next)
    },
    beforeRouteUpdate(to, from, next) {
        this.checkBeforeRoute(next)
    },
    data() {
        return {
            mounted: false,
            sample: null,
            labId: null,
            showCase: true,
            showSample: true,
            viewSelected: FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id,
            casId: null,
            caseInformation: null,
            transcriptionStatus: false,
            coreEntity: '',
            patientPreviousCasesCount: null,
            changingTranscriptionRequired: false,
            invalidateMaxTimeInHoursAfterValidation: null,
            customSentNotificationsSummary: null,
            entitiesIdArray: [this.labId, this.casId],
            consultations: [],
            sideBarState: diagnosisSideBarStore.state
        }
    },
    computed: {
        caseLabel() {
            return this.caseInformation?.casenumber ?? '-'
        },
        sideBarExternalFilterModel() {
            return this.sideBarState.externalFilterModel
        },
        showBreadCrumbs() {
            return this.mounted && !this.$_isCaseDraft(this.caseInformation.status.code)
        },
        getSamples() {
            return this.$refs.samplesView?.$refs.samplesCards?.samples
        },
        disabledInformAndValidateButton() {
            return this.caseInformation.transcriptionRequired || !this.$_canBeCaseInformed(this.caseInformation)
        },
        casePathologistId() {
            return this.caseInformation?.pathologist?.id
        },
        ENTITIES() {
            return ATTACHMENT_ENTITY_TYPE
        },
        subportionAttachmentService() {
            return subportionAttachmentService
        },
        portionAttachmentService() {
            return portionAttachmentService
        },
        patientAttachmentService() {
            return patientAttachmentService
        },
        caseAttachmentService() {
            return caseAttachmentService
        },
        sampleAttachmentService() {
            return sampleAttachmentService
        },
        userPersonnelId() {
            return sessionStore.getUserPersonnelId()
        },
        CASE_STATES() {
            return CASE_STATES
        },
        FORM_VIEWS_CONFIGURATION() {
            return FORM_VIEWS_CONFIGURATION
        },
        patientTimeOld() {
            return this.caseInformation ? this.getPatientTimeOld(this.caseInformation.patient.birthdate || this.caseInformation.patient.patBirthdate) : null
        },
        isCaseTranscribed() {
            return this.caseInformation?.status?.code === CASE_STATES.TRANSCRIBED.code
        },
        visibleConsultations() {
            return !!this.consultations.filter(
                consultation => consultation.status.code === DiagnosisConsultationStatusEnum.PENDING &&
                consultation.receiver.id === this.userPersonnelId).length
        },
        visibleInformButton() {
            return this.$_canBeCaseInformed(this.caseInformation) &&
                this.$_canInformCases()
        },
        visibleInformAndValidateButton() {
            return this.$_canBeCaseInformed(this.caseInformation) &&
                this.$_canInformCases() &&
                this.$_canValidateCases()
        },
        visibleValidateButton() {
            return this.$_canValidateCases() && this.$_canBeCaseValidated(this.caseInformation)
        },
        visibleInvalidateButton() {
            return this.$_canBeCaseInvalidated(this.caseInformation)
        },
        visibleTranscribeButton() {
            return this.$_canTranscribeToCase(this.caseInformation.status.code, this.caseInformation.transcriptionRequired)
        },
        visibleAmendButton() {
            return this.$_canAmendToCase(this.caseInformation, this.invalidateMaxTimeInHoursAfterValidation)
        },
        visibleValidateAmendmentButton() {
            return this.$_isCaseInAmendment(this.caseInformation && this.caseInformation.status.code)
        },
        consultationToolbarSelectorTypeEnum() {
            return ConsultationToolbarSelectorTypeEnum
        }
    },
    watch: {
        sideBarExternalFilterModel(newValue) {
            if (!this.$_isEmpty(newValue)) {
                this.$emit('updateSummary')
            }
        }
    },
    async created() {
        if (this.viewSelected === FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id) {
            this.casId = +this.$route.params.casId
            this.labId = +this.$route.params.labId
        }
        await this.getCustomSentNotifications()
        viewerService.closeViewersOfDifferentCase(`${this.casId}`)
        this.$eventHub.$on('changeRouteWithCheckChanges', this.checkIfDataHasBeenChangedWhenChangedLaboratoryAndGoToRoute)
    },
    async mounted() {
        await this.reloadCase()
        await this.getPatientPreviousCasesCount()
        this.updateLoading(false)
        if (this.$route.params.samId) {
            this.$nextTick(() => this.$refs.samplesView.selectSample(this.$route.params.samId))
        }
        this.mounted = true
        this.$eventHub.$on('updatePatientInformation', this.onUpdatePatient)
    },
    beforeDestroy() {
        this.$eventHub.$off('changeRouteWithCheckChanges', this.checkIfDataHasBeenChangedWhenChangedLaboratoryAndGoToRoute)
        this.$eventHub.$off('updatePatientInformation', this.onUpdatePatient)
    },
    methods: {
        checkBeforeRoute(goToRoute) {
            this.updateLoading(false)
            if (!router.currentRoute.meta.skipChecking) {
                this.changeView(this.viewSelected, goToRoute)
            } else {
                router.currentRoute.meta.skipChecking = false
                goToRoute()
            }
        },
        onUpdatePatient(updatedPatient) {
            if (updatedPatient.patId === this.caseInformation.patient.id) {
                this.caseInformation.patient = {
                    ...cloneDeep(this.caseInformation.patient),
                    birthdate: updatedPatient.patBirthdate,
                    mainPatientIdentifier: updatedPatient.mainPatientIdentifier,
                    secondaryPatientIdentifier: updatedPatient.secondaryPatientIdentifier,
                    fullName: updatedPatient.fullName
                }
            }
        },
        showSampleCard(value) {
            this.showSample = value
        },
        hideSampleCard(value) {
            this.showSample = value
        },
        async reloadCaseAndSampleActiveTab() {
            await this.reloadCase()
            if (this.$refs.samplesView) {
                await this.$refs.samplesView.reloadActiveTab()
            }
        },
        showCustomSentNotifications() {
            this.$refs.diagnosisMainButtons.showCustomNotificationsModal(true)
        },
        async getCustomSentNotifications() {
            this.updateLoading(true)
            const [err, response] = await this.toCall(customNotificationsService.getAllCustomSentNotifications(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.customSentNotificationsSummary = response.length
        },
        async addAmendment() {
            this.updateLoading(true)
            const [err] = await this.toCall(diagnosisCaseService.addAmendment(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.showSuccessModalGlobal(this.$t('diagnosis.amendmentAddedSuccessfully'))
            await this.reloadCaseAndSampleActiveTab()
        },
        async validateAmendment() {
            this.updateLoading(true)
            const [err] = await this.toCall(diagnosisCaseService.finishAmendment(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.$_showErrorModalFromErrorResponse(err)
                return
            }
            this.showSuccessModalGlobal(this.$t('diagnosis.amendmentValidatedSuccessfully'))
            await this.reloadCaseAndSampleActiveTab()
        },
        async showAPReport() {
            const getCaseReportPDFParams = {
                laboratoryId: this.labId,
                caseId: this.casId,
                caseLabel: this.caseData?.casCasenumber,
                print: false
            }
            await HelperUtils.getCaseReportPDF(getCaseReportPDFParams)
        },
        async reloadViewAfterIncidentOrAttachmentAdded() {
            await this.reloadCase()
            if (this.viewSelected === FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id) {
                if (this.$refs.samplesView.activeTabIndex === this.$refs.samplesView.SAMPLE_TAB_INDEX) {
                    await this.$refs.samplesView.$refs.samplesCards.loadSamples()
                } else {
                    await this.$refs.samplesView.$refs.subportionSection.loadPortionsMaitainingOpened()
                    await this.$refs.samplesView.$refs.subportionSection.setGridData()
                }
            } else if (this.viewSelected === FORM_VIEWS_CONFIGURATION.COMPLEMENTARIES_VIEW.id) {
                await this.$refs.complementariesView.loadComplementaries()
                await this.$refs.complementariesView.loadDescriptionAudioAttachments()
            }
        },
        async getPatientPreviousCasesCount() {
            const [err, response] = await this.toCall(commonCaseServices.patientPreviousCasesCountByLaboratory(this.labId, this.caseInformation.patient.id))
            if (err) {
                this.showErrorModalGlobal()
            }
            this.patientPreviousCasesCount = response.count
        },
        async showAddFileModal(entity, entitiesIds) {
            this.coreEntity = entity
            this.entitiesIdArray = entitiesIds
            this.$refs.addFileModalWrapper.show()
        },
        async onAttachmentsAdded() {
            await this.reloadViewAfterIncidentOrAttachmentAdded()
        },
        selectSampleFromMacro(samId) {
            this.$route.params.samId = samId
            this.viewSelected = FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id
        },
        openIncidentFormModal(coreEntity, entitiesIds) {
            this.coreEntity = coreEntity
            this.$nextTick(() => {
                this.$refs.incidentFormModal.show(null, entitiesIds)
            })
        },
        showReportHistoryModal() {
            this.$refs.reportHistoryModal.show(this.casId)
        },
        async updateTranscriptionRequired() {
            if (this.changingTranscriptionRequired) {
                this.changingTranscriptionRequired = false
                return
            }
            const successfulChange = await this.$refs.diagnosisCaseCard.updateCase({ transcriptionRequired: this.caseInformation.transcriptionRequired })
            if (!successfulChange) {
                // changingTranscriptionRequired is used to avoid infinite looping as we are changing the attribute whose change generates the event
                this.changingTranscriptionRequired = true
                this.caseInformation.transcriptionRequired = !this.caseInformation.transcriptionRequired
            }
        },
        openPatientPreviousCasesModal() {
            this.closePreviousCasesWindow()
            const routeData = router.resolve({ name: 'patientCases', params: { patId: this.caseInformation.patient.id, labId: this.$store.getters.labId } })
            this.patientPreviousCasesWindowsReference = window.open(routeData.href, '_blank')
        },
        openPatientModal() {
            this.$refs.searchPatientModal.show()
        },
        openIncidentsModal(defaultOption) {
            const patientId = this.caseInformation.patient.id
            this.$refs.incidentModalTree.show(defaultOption, patientId)
        },
        openAttachModalPatient() {
            this.$refs.attachmentTreeModal.showPatient()
        },
        openAttachModalCase(casId) {
            this.$refs.attachmentTreeModal.showCase(casId)
        },
        openAttachModalSample(samId) {
            this.$refs.attachmentTreeModal.showSample(samId)
        },
        openAttachModalComplementary(complementaryId) {
            this.$refs.attachmentTreeModal.showComplementary(complementaryId)
        },
        openAttachModalSubportion(supId) {
            this.$refs.attachmentTreeModal.showSubportion(supId)
        },
        hideAll() {
            this.showCase = false
            this.showSample = false
        },
        showAll() {
            this.showCase = true
            this.showSample = true
        },
        showPatientModal() {
            this.$refs.modalPatientCard.show()
        },
        async reloadCase() {
            try {
                this.updateLoading(true)
                this.$emit('updateSummary')
                const response = await this.$_toCallSecureLoading(diagnosisCaseService.getDiagnosisCaseByCaseId(this.labId, this.casId))
                if (response) {
                    if (!this.invalidateMaxTimeInHoursAfterValidation) {
                        await this.loadInvalidateMaxTimeInHoursAfterValidation()
                    }
                    this.caseInformation = response
                    this.consultations = await this._getConsultations(this.casId)
                }
            } finally {
                this.updateLoading(false)
            }
        },
        async _getConsultations(caseId) {
            const response = await this.$_toCallSecureLoading(diagnosisConsultationService.getConsultations(this.labId, caseId))
            return response ?? []
        },
        closePreviousCasesWindow() {
            if (this.patientPreviousCasesWindowsReference) {
                this.patientPreviousCasesWindowsReference.close()
            }
        },
        async changeView(viewId, goToRoute) {
            const activeView = this.getActiveView()
            let action = goToRoute || function() { this.viewSelected = viewId }.bind(this)
            if (this.viewSelected === FORM_VIEWS_CONFIGURATION.MACRO_VIEW.id) {
                action()
            } else if (activeView) {
                await activeView.checkChangesInActiveTabAndApplyAction(action)
            } else {
                this.viewSelected = viewId

                if (goToRoute) {
                    goToRoute()
                }
            }
            this.closePreviousCasesWindow()
        },
        async checkIfDataHasBeenChangedWhenChangedLaboratoryAndGoToRoute(goToRoute) {
            router.currentRoute.meta.skipChecking = true
            const activeView = this.getActiveView()
            if (activeView) {
                await activeView.checkChangesInActiveTabAndApplyAction(goToRoute, true)
            } else {
                await HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
            }
            this.closePreviousCasesWindow()
        },
        async saveChangesAndApplyAction(action) {
            const activeView = this.getActiveView()
            if (activeView) {
                await activeView.saveChangesInActiveTabAndApplyAction(action)
            }
        },
        getActiveView() {
            if (this.viewSelected === FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id) {
                return this.$refs.samplesView
            } else if (this.viewSelected === FORM_VIEWS_CONFIGURATION.DIAGNOSIS_INTEGRAL_VIEW.id) {
                return this.$refs.integralView
            } else if (this.viewSelected === FORM_VIEWS_CONFIGURATION.COMPLEMENTARIES_VIEW.id) {
                return this.$refs.complementariesView
            } else {
                return null
            }
        },
        async validateCase() {
            const correctPathologist = await this.checkCorrectPathologist(CaseOperation.GLOBAL_VALIDATE)
            if (correctPathologist) {
                if (await this.internalValidateCaseMixin(this.labId, this.casId)) {
                    this.showToastSuccessGlobal(this.$t('diagnosis.validateSuccess'))
                    await this.reloadCaseAndSampleActiveTab()
                }
            }
        },
        async checkCorrectPathologist(operationCode = null) {
            if (this.isCorrectPathologistAssigned(operationCode,
                this.casePathologistId,
                this.userPersonnelId,
                this.caseInformation?.pathologist?.allowsCaseValidationByOtherUsers,
                this.labId)) {
                return true
            } else {
                const changePathologistAnswer = await this.showConfirmationModalGlobal(this.$t('diagnosis.wrongPathologist'), this.$t('global.yes'), this.$t('global.no'), 'confirmationModalGlobal-CheckCorrectPathologist')
                if (changePathologistAnswer) {
                    return this.$refs.diagnosisCaseCard.updateCase({ pathologistPerId: this.userPersonnelId })
                } else {
                    return false
                }
            }
        },
        async transcribeCase() {
            this.updateLoading(true)
            const [err] = await this.toCall(diagnosisCaseService.transcribeCase(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.showToastSuccessGlobal(this.$t('diagnosis.transcribeSuccess'))
            await this.reloadCaseAndSampleActiveTab()
        },
        async informCase() {
            this.updateLoading(true)
            const [err] = await this.toCall(diagnosisCaseService.informCase(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.$_showErrorModalFromErrorResponse(err)
                return false
            }
            this.$_showToastSuccess(this.$t('diagnosis.informSuccess'))
            await this.reloadCaseAndSampleActiveTab()
            return true
        },
        async informAndValidate() {
            if (await this.informCase()) {
                await this.validateCase()
            }
        },
        async loadInvalidateMaxTimeInHoursAfterValidation() {
            const response = await this.$_toCallSecureLoading(parameterService.findInvalidateMaxTimeInHoursAfterValidation(this.labId))
            if (response) {
                this.invalidateMaxTimeInHoursAfterValidation = response
            }
        },
        async invalidateCase() {
            this.updateLoading(true)
            const [err] = await this.toCall(diagnosisCaseService.invalidateCase(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.$_showErrorModalFromErrorResponse(err)
                return
            }
            this.showToastSuccessGlobal(this.$t('diagnosis.invalidateSuccess'))
            await this.reloadCaseAndSampleActiveTab()
        },
        async exportPatientPreviousCasesReportPDF() {
            await this.$refs.printComponent.printReport(
                reportType.CASE_REPORT,
                () => PromiseUtils.toCallSecure(
                    PatientResource.getPreviousCaseAPReport(
                        this.$store.getters.labId,
                        this.caseInformation.patient.id,
                        true
                    )
                )
            )
        },
        async showConsultationModal(selectorType) {
            await this.$refs.consultationModal.show(selectorType)
        },
        visibleHasUnauthorizedBillableConceptsIcon(hasUnauthorizedBillableConcepts) {
            return ModuleOperationGuard.canAccessBilling && hasUnauthorizedBillableConcepts
        },
        async onReloadInfoConcepts() {
            this.updateLoading(true)
            const response = await this.$_toCallSecure(diagnosisCaseService.getDiagnosisCaseByCaseId(this.labId, this.casId))
            this.caseInformation = response ?? this.caseInformation
            await this.$refs.samplesView.$refs.samplesCards.loadSamples()
            if (
                this.$refs.samplesView.activeTabIndex === this.$refs.samplesView.SUBPORTION_TAB_INDEX &&
                    !this.$refs.samplesView.$refs.subportionSection.viewToggle
            ) {
                await this.$refs.samplesView.$refs.subportionSection.setGridData()
            }
            this.updateLoading(false)
        }
    }
}
</script>

<style lang="scss">
    /*-- Provisional layout for overflow responsive --*/
    /* -- TODO Refactoring required --*/
    .diagnosis-case__container {
        flex-grow: 1;
        min-height: 0;
        .case-col {
            height: calc(100% - 40px);
            @include mq(tablet-medium, max) {
                height: auto;
            }
            .diagnosis-case-card {
                height: 100%;
                min-height: 0;
                display: flex;
                flex-direction: column;
                @include mq(tablet-medium, max) {
                    height: auto;
                }
                .card-footer {
                    @include mq(tablet-medium, max) {
                        display: none;
                    }
                }
                .card-body {
                    height: 100%;
                    min-height: 0;
                    display: flex;
                    flex-direction: column;
                    .fixed-section {
                        padding: 0.65rem;
                    }
                    .diagnosis-case-card-content {
                        flex-grow: 1;
                        min-height: 0;
                        display: flex;
                        flex-direction: column;
                    }
                }
            }
        }
        .case-compact-col {
            .diagnosis-case-card {
                height: calc(100% - 40px);
            }
        }
        .workarea-col {
            height: calc(100% - 40px);
            display: flex;
            flex-direction: column;
            min-height: 0;
            .entity-card {
                .additional-data {
                    @include mq(desktop, max) {
                         display: none !important;
                    }
                }
            }
            .main-card {
                flex-grow: 1;
                min-height: 0;
                display: flex;
                flex-direction: column;
                .container {
                    flex-grow: 1;
                    min-height: 0;
                    .row {
                        /*height: 100%;*/
                        .col {
                            height: 100%;
                            .samplesDiagnosisView,
                            .integralDiagnosisView,
                            .complementaryDiagnosisView {
                                height: 100%;
                                .sample-content {
                                    height: 100%;
                                    min-height: 0;
                                }
                                .sample-col {
                                    @include mq(desktop, max) {
                                        max-width: 125px;
                                    }
                                }
                                .data-col {
                                    height: 100%;
                                    .card-body .section-col_container {
                                        height: 100%;
                                        .section-col_row {
                                            height: 100%;
                                            .diagnosis-content {
                                                height: 100%;
                                                padding-top: 15px;
                                                padding-bottom: 15px;
                                                .tabs {
                                                    .col-auto {
                                                        height: 100%;
                                                    }
                                                }
                                                .tab-pane {
                                                    height: 100%;
                                                    .section-content-grid {
                                                        height: 100%;
                                                        .section-grid__container {
                                                            height: 100%;
                                                            display: flex;
                                                            flex-direction: column;
                                                            .section-grid__height {
                                                                height: auto;
                                                                flex-grow: 1;
                                                                .vt-grid {
                                                                    height: 100%;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    .section-content {
                                                        height: 100%;
                                                        .section-editor__container {
                                                            display: flex;
                                                            flex-direction: column;
                                                            min-height: 0;
                                                        }
                                                        .descriptionEditor {
                                                            height: 100%;
                                                            min-height: 0;
                                                            display: flex;
                                                            flex-direction: column;
                                                            .header-banner {
                                                                height: auto;
                                                            }
                                                            .diagnosis-layout-height {
                                                                height: auto;
                                                                min-height: 0;
                                                                flex-grow: 1;
                                                                .quill-editor {
                                                                    height: 100%;
                                                                    margin-top : 0 !important;
                                                                    display: flex;
                                                                    flex-direction: column;
                                                                    .ql-container {
                                                                        flex-grow: 1;
                                                                        min-height: 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

.case-inform .gr-card-info .no-wrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.case-inform .is-compact .flagdot i{
  margin-right: 0 !important;
}

.case-inform .is-compact .showtooltip{
  display: block !important;
  cursor: pointer;
}

.case-inform .is-compact .noshowtooltip{
  display: none !important;
}

.case-inform .is-compact .status-badge.contract {
    text-indent: -9999px;
    max-width: 10px !important;
    min-width: 10px !important;
    height: 10px;
    font-size: 0 !important;
}

</style>
